import api from './api';
import { trackPromise } from 'react-promise-tracker';
import { getJwt } from '@app/helpers';
import Axios from 'axios';

export interface ResumoMedicoesFilter {
  dataInicio: string;
  dataFinal: string;
  diretoriaIds: string;
  analistaGPCIds: string;
  fornecedorIds: string;
  numeroContrato: string;
  areaIds: string;
  departamentoIds: string;
}

export interface ResumoMedicoesBase {
  relatorioData: RelatorioStatusMedicoes[];
  relatorioResumoData: RelatorioStatusMedicoesResume[];
  gerirDocumentacaoAcessoria: boolean;
}

export interface RelatorioStatusMedicoes {
  numeroContrato?: string;
  fornecedor?: string;
  analistaGPC?: string;
  diretoria?: string;
  area?: string;
  departamento?: string;
  dataInicio?: string;
  dataFim?: string;
  statusMedicao?: string;
  avanco?: string;
  statusDocumentacaoAcessoriaMensal?: string;
  dataCriacaoBM?: string;
  valorBM?: string;
  possuiSLA?: string;
  bonus?: string;
  penalti?: string;
  numeroAutorizacao?: string;
  dataEnvioAutorizacaoFornecedor?: string;
  dataEmissaoDocumento?: string;
}

export interface RelatorioStatusMedicoesResume {
  qtnDeMedicoes?: string;
  qtnMedicoesEmAndamento?: string;
  qtnMedicoesNaoLancadas?: string;
  qtnMedicoesConcluidas?: string;
  valorMedicoesConcluidas?: string;
}

export const searchValues = (values: ResumoMedicoesFilter) => {
  return api.post<ResumoMedicoesBase>('relatorios/resumomedicao', values, {
    disableNotification: 'true',
  });
};

export const relatorioExportExcel = (values: ResumoMedicoesFilter) => {

  let urlBase = window.location.origin;
  trackPromise(Axios.post(urlBase + `/api/relatorios/resumomedicao/excel`, values,
    {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "relatorio_medicao.xlsx");
      link.setAttribute('id', 'downloadElementrelatorio_medicao');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElementrelatorio_medicao').outerHTML = '';
    }));
};

